import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Suspense as _Suspense, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "w-3 mr-2"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mb-2 font-bold" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "grid mb-3" }
const _hoisted_9 = { class: "col-12 lg:col-4" }
const _hoisted_10 = {
  key: 0,
  class: "card"
}
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = {
  key: 1,
  class: "card"
}
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = {
  key: 2,
  class: "card"
}
const _hoisted_15 = { class: "p-fluid" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "p-fluid" }
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "p-fluid" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "p-fluid" }
const _hoisted_22 = { class: "col-12 lg:col-4" }
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "p-fluid" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "p-fluid" }
const _hoisted_27 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_28 = {
  key: 0,
  class: "card"
}
const _hoisted_29 = { class: "p-fluid" }
const _hoisted_30 = {
  key: 1,
  class: "card"
}
const _hoisted_31 = { class: "p-fluid" }
const _hoisted_32 = { class: "p-fluid" }
const _hoisted_33 = {
  key: 2,
  class: "card"
}
const _hoisted_34 = { class: "p-fluid" }
const _hoisted_35 = { class: "card" }
const _hoisted_36 = { class: "p-fluid" }
const _hoisted_37 = {
  key: 3,
  class: "card"
}
const _hoisted_38 = { class: "p-fluid" }
const _hoisted_39 = { class: "card" }
const _hoisted_40 = { class: "card-header" }
const _hoisted_41 = { class: "card-title" }
const _hoisted_42 = { class: "p-fluid" }
const _hoisted_43 = {
  key: 4,
  class: "card"
}
const _hoisted_44 = { class: "card-header align-items-center" }
const _hoisted_45 = { class: "card-title" }
const _hoisted_46 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_47 = { class: "p-fluid" }
const _hoisted_48 = { class: "card" }
const _hoisted_49 = { class: "p-fluid" }
const _hoisted_50 = {
  key: 5,
  class: "card"
}
const _hoisted_51 = { class: "p-fluid" }
const _hoisted_52 = {
  key: 7,
  class: "card"
}
const _hoisted_53 = { class: "card-header" }
const _hoisted_54 = { class: "card-title" }
const _hoisted_55 = { class: "p-fluid" }
const _hoisted_56 = { class: "col-12 lg:col-4" }
const _hoisted_57 = {
  key: 0,
  class: "card"
}
const _hoisted_58 = { class: "card-header" }
const _hoisted_59 = { class: "card-title" }
const _hoisted_60 = { class: "p-fluid" }
const _hoisted_61 = { class: "card" }
const _hoisted_62 = { class: "p-fluid" }
const _hoisted_63 = {
  key: 1,
  class: "card"
}
const _hoisted_64 = { class: "p-fluid" }
const _hoisted_65 = {
  key: 2,
  class: "card"
}
const _hoisted_66 = { class: "p-fluid" }
const _hoisted_67 = { class: "grid mb-3" }
const _hoisted_68 = {
  key: 0,
  class: "col-12 lg:col-4"
}
const _hoisted_69 = { class: "card" }
const _hoisted_70 = { class: "p-fluid" }
const _hoisted_71 = { class: "col-12 lg:col-4" }
const _hoisted_72 = { class: "card" }
const _hoisted_73 = { class: "p-fluid" }
const _hoisted_74 = { class: "grid mb-3" }
const _hoisted_75 = { class: "col-12 lg:col-4" }
const _hoisted_76 = { class: "card" }
const _hoisted_77 = { class: "p-fluid" }
const _hoisted_78 = {
  key: 0,
  class: "col-12 lg:col-4"
}
const _hoisted_79 = { class: "card" }
const _hoisted_80 = { class: "p-fluid" }
const _hoisted_81 = {
  key: 1,
  class: "col-12 lg:col-4"
}
const _hoisted_82 = { class: "card" }
const _hoisted_83 = { class: "p-fluid" }
const _hoisted_84 = { class: "col-12 lg:col-4" }
const _hoisted_85 = { class: "card" }
const _hoisted_86 = { class: "p-fluid" }
const _hoisted_87 = { class: "col-12 lg:col-4" }
const _hoisted_88 = { class: "card" }
const _hoisted_89 = { class: "p-fluid" }
const _hoisted_90 = { class: "grid mb-2" }
const _hoisted_91 = { class: "col-12 lg:col-6" }
const _hoisted_92 = { class: "col-12 lg:col-6" }
const _hoisted_93 = { class: "col-12 lg:col-4" }
const _hoisted_94 = { class: "card" }
const _hoisted_95 = { class: "p-fluid" }
const _hoisted_96 = {
  key: 0,
  class: "grid mb-3"
}
const _hoisted_97 = { class: "col-12 lg:col-4" }
const _hoisted_98 = { class: "card" }
const _hoisted_99 = { class: "p-fluid" }
const _hoisted_100 = { class: "grid mb-3" }
const _hoisted_101 = { class: "col-12 lg:col-4" }
const _hoisted_102 = { class: "card" }
const _hoisted_103 = { class: "p-fluid" }
const _hoisted_104 = { class: "col-12 lg:col-4" }
const _hoisted_105 = { class: "card" }
const _hoisted_106 = { class: "p-fluid" }
const _hoisted_107 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_108 = { class: "col-12 lg:col-4" }
const _hoisted_109 = { class: "card" }
const _hoisted_110 = { class: "p-fluid" }
const _hoisted_111 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_112 = { class: "grid mb-3" }
const _hoisted_113 = {
  key: 0,
  class: "col-12 lg:col-4"
}
const _hoisted_114 = { class: "card" }
const _hoisted_115 = { class: "p-fluid" }
const _hoisted_116 = { class: "col-12 lg:col-4" }
const _hoisted_117 = { class: "card" }
const _hoisted_118 = { class: "p-fluid" }
const _hoisted_119 = {
  key: 1,
  class: "col-12 lg:col-4"
}
const _hoisted_120 = { class: "card" }
const _hoisted_121 = { class: "p-fluid" }
const _hoisted_122 = {
  key: 2,
  class: "col-12 lg:col-4"
}
const _hoisted_123 = { class: "card" }
const _hoisted_124 = { class: "p-fluid" }
const _hoisted_125 = { class: "col-12 lg:col-4" }
const _hoisted_126 = { class: "card" }
const _hoisted_127 = { class: "p-fluid" }
const _hoisted_128 = { class: "grid mb-3" }
const _hoisted_129 = { class: "col-12 lg:col-4" }
const _hoisted_130 = { class: "p-fluid" }
const _hoisted_131 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_132 = { class: "col-12 lg:col-4" }
const _hoisted_133 = { class: "p-fluid" }
const _hoisted_134 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_135 = { class: "col-12 lg:col-4" }
const _hoisted_136 = { class: "card" }
const _hoisted_137 = { class: "p-fluid" }
const _hoisted_138 = { class: "p-fluid" }
const _hoisted_139 = { class: "p-fluid" }
const _hoisted_140 = { class: "grid" }
const _hoisted_141 = { class: "col-12 lg:col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueToast = _resolveComponent("PrimeVueToast")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!
  const _component_FieldVertical = _resolveComponent("FieldVertical")!
  const _component_FieldFolders = _resolveComponent("FieldFolders")!
  const _component_Creatives = _resolveComponent("Creatives")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_Macros = _resolveComponent("Macros")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_FieldBidCPC = _resolveComponent("FieldBidCPC")!
  const _component_FieldBidCPM = _resolveComponent("FieldBidCPM")!
  const _component_CustomBids = _resolveComponent("CustomBids")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_MaxClicksBySubids = _resolveComponent("MaxClicksBySubids")!
  const _component_ApprovalStatusComment = _resolveComponent("ApprovalStatusComment")!
  const _component_FieldListBox = _resolveComponent("FieldListBox")!
  const _component_FieldListBoxRemote = _resolveComponent("FieldListBoxRemote")!
  const _component_TargetingByValues = _resolveComponent("TargetingByValues")!
  const _component_FieldTimezone = _resolveComponent("FieldTimezone")!
  const _component_ScheduleByHours = _resolveComponent("ScheduleByHours")!
  const _component_ScheduleByDays = _resolveComponent("ScheduleByDays")!
  const _component_FieldDate = _resolveComponent("FieldDate")!
  const _component_AdSecure = _resolveComponent("AdSecure")!
  const _component_Entry = _resolveComponent("Entry")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PrimeVueToast, {
      position: "bottom-right",
      group: "bc"
    }, {
      message: _withCtx(({ message }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(message.detail.compiled_name), 1),
          _createElementVNode("div", _hoisted_3, [
            (message.detail.icon_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "w-full border-round-sm",
                    src: message.detail.icon_url
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(message.detail.title), 1),
              _createElementVNode("div", null, _toDisplayString(message.detail.description), 1)
            ])
          ]),
          (message.detail.image_url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "block mt-2 w-full border-round-sm",
                src: message.detail.image_url
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Entry, {
      title: _ctx.$t('campaign'),
      entry: _ctx.campaign,
      "entry-errors-map": _ctx.campaignErrorsMap,
      "onUpdate:entryErrorsMap": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.campaignErrorsMap) = $event)),
      "entry-fetch-handler": _ctx.fetchCampaign,
      "entry-store-handler": _ctx.storeCampaign,
      "href-prefix": "campaigns",
      "on-entry-store-redirect-to-entries": ""
    }, {
      "buttons-col-2-prepend": _withCtx(() => [
        (!!_ctx.campaign.id)
          ? (_openBlock(), _createBlock(_component_PrimeVueButton, {
              key: 0,
              class: "p-button-secondary ml-4 mb-0",
              label: _ctx.$t('clone'),
              icon: "pi pi-copy",
              onClick: _ctx.cloneCampaign
            }, null, 8, ["label", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('common_settings')) + " ⚙️", 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.campaign.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.campaign.id,
                      label: "ID",
                      disabled: ""
                    }, null, 8, ["model-value"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isSuperAdmin())
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.project_id,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.campaign.project_id) = $event)),
                        _ctx.onProjectChange
                      ],
                      modelModifiers: { number: true },
                      name: "project_id",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('project'),
                      loading: _ctx.projectsLoading,
                      disabled: !!_ctx.campaign.id,
                      options: _ctx.projects.data,
                      "option-value": "id",
                      "option-label": "name"
                    }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_FieldDropdownAutoComplete, {
                      modelValue: _ctx.campaign.user_id,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.campaign.user_id) = $event)),
                        _ctx.onUserChange
                      ],
                      modelModifiers: { number: true },
                      name: "user_id",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('user'),
                      disabled: !!_ctx.campaign.id,
                      "api-url": "/api/v3/users/options",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "errors-map", "label", "disabled", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FieldText, {
                  modelValue: _ctx.campaign.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.campaign.name) = $event)),
                  modelModifiers: { trim: true },
                  name: "name",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('name')
                }, null, 8, ["modelValue", "errors-map", "label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.traffic_type,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.campaign.traffic_type) = $event)),
                    _ctx.onTrafficTypeChange
                  ],
                  modelModifiers: { number: true },
                  name: "traffic_type",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('traffic_type'),
                  disabled: !!_ctx.campaign.id,
                  options: _ctx.trafficTypeOptions
                }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"]),
                (_ctx.isBanner)
                  ? (_openBlock(), _createBlock(_component_FieldDropdownNext, {
                      key: 0,
                      modelValue: _ctx.campaign.creative_image_format,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.campaign.creative_image_format) = $event)),
                        _ctx.onCreativeImageFormatChange
                      ],
                      name: "creative_image_format",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: "Format",
                      help: _ctx.campaign.creative_image_format ? null : 'Combine multiple creative sizes in one campaign to reach all available ad slots',
                      placeholder: "Cross-format",
                      disabled: !!_ctx.campaign.id,
                      options: _ctx.CREATIVE_IMAGE_FORMATS,
                      "show-clear": ""
                    }, null, 8, ["modelValue", "errors-map", "help", "disabled", "options", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.user.isStaff())
                  ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                      key: 1,
                      modelValue: _ctx.campaign.mix_traffic_type,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.campaign.mix_traffic_type) = $event)),
                      label: _ctx.$t('mix_traffic_type')
                    }, null, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.traffic_category,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.campaign.traffic_category) = $event)),
                  modelModifiers: { number: true },
                  name: "traffic_category",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: "Category",
                  disabled: !!_ctx.campaign.id && _ctx.user.isAffiliate(),
                  options: _ctx.TRAFFIC_CATEGORIES
                }, null, 8, ["modelValue", "errors-map", "disabled", "options"]),
                (_ctx.user.isStaff())
                  ? (_openBlock(), _createBlock(_component_FieldVertical, {
                      key: 2,
                      modelValue: _ctx.campaign.vertical_id,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.campaign.vertical_id) = $event)),
                      modelModifiers: { number: true },
                      name: "vertical_id",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('vertical')
                    }, null, 8, ["modelValue", "errors-map", "label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_FieldFolders, {
                  modelValue: _ctx.campaign.folder_ids,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.campaign.folder_ids) = $event)),
                  name: "folder_ids",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('folders'),
                  "allow-create": ""
                }, null, 8, ["modelValue", "errors-map", "label"])
              ])
            ]),
            (_ctx.canHasCreatives)
              ? (_openBlock(), _createBlock(_component_Creatives, {
                  key: 3,
                  modelValue: _ctx.campaign.creatives,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.campaign.creatives) = $event)),
                  options: _ctx.creatives.data,
                  "options-loading": _ctx.creativesLoading,
                  "option-value": "id",
                  "option-label": "compiled_name",
                  onPreviewCreative: _ctx.previewCreative
                }, null, 8, ["modelValue", "options", "options-loading", "onPreviewCreative"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_FieldTextarea, {
                  modelValue: _ctx.campaign.click_url,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.campaign.click_url) = $event)),
                  modelModifiers: { trim: true },
                  name: "click_url",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('click_url'),
                  help: `${_ctx.$t('max_length')}: 1024 ${_ctx.$t('chars')}`
                }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Macros, {
                      class: "mt-3",
                      macros: _ctx.macros
                    }, null, 8, ["macros"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                  ]),
                  _: 1
                }))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.payment_type,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.campaign.payment_type) = $event)),
                  modelModifiers: { number: true },
                  name: "payment_type",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('payment_type'),
                  help: _ctx.$t(_ctx.CAMPAIGN_PAYMENT_TYPES_MAP[_ctx.campaign.payment_type].help),
                  disabled: !!_ctx.campaign.id,
                  options: _ctx.paymentTypeOptions
                }, null, 8, ["modelValue", "errors-map", "label", "help", "disabled", "options"])
              ])
            ]),
            (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPC || _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPC)
                        ? (_openBlock(), _createBlock(_component_FieldBidCPC, {
                            key: _ctx.campaign.bid,
                            modelValue: _ctx.campaign.bid,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.campaign.bid) = $event)),
                            modelModifiers: { number: true },
                            name: "bid",
                            "errors-map": _ctx.campaignErrorsMap,
                            min: 0
                          }, null, 8, ["modelValue", "errors-map"]))
                        : _createCommentVNode("", true),
                      (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM || _ctx.campaign.traffic_type === _ctx.TRAFFIC_TYPE_POP)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.campaign.bid > 0.10 && _ctx.campaign.traffic_type === _ctx.TRAFFIC_TYPE_POP)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t('pop_bid_is_too_high')), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(), _createBlock(_component_FieldBidCPM, {
                              key: _ctx.campaign.bid,
                              modelValue: _ctx.campaign.bid,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.campaign.bid) = $event)),
                              modelModifiers: { number: true },
                              name: "bid",
                              "errors-map": _ctx.campaignErrorsMap,
                              min: 0
                            }, null, 8, ["modelValue", "errors-map"]))
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.user.isStaff())
                        ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                            key: 2,
                            modelValue: _ctx.campaign.ignore_max_bid,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.campaign.ignore_max_bid) = $event)),
                            label: _ctx.$t('ignore_max_bid'),
                            help: _ctx.$t('ignore_max_bid_help')
                          }, null, 8, ["modelValue", "label", "help"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomBids, {
                        modelValue: _ctx.campaign.bids_by_countries_ids,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.campaign.bids_by_countries_ids) = $event)),
                        title: _ctx.$t('bid_by_countries', { type: _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM ? 'CPM' : 'CPC' }),
                        "entry-title": _ctx.$t('country'),
                        "per-thousand": _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM,
                        min: 0
                      }, {
                        key: _withCtx(({ customBid }) => [
                          _createVNode(_component_FieldDropdownNext, {
                            class: "mb-0",
                            modelValue: customBid.key,
                            "onUpdate:modelValue": ($event: any) => ((customBid.key) = $event),
                            modelModifiers: { number: true },
                            loading: _ctx.countriesLoading,
                            "show-clear": "",
                            filter: "",
                            options: _ctx.countries.data,
                            "option-value": "id",
                            "option-label": "compiled_name"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "loading", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "title", "entry-title", "per-thousand"])
                    ]),
                    fallback: _withCtx(() => [
                      _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                    ]),
                    _: 1
                  })),
                  (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPC && !_ctx.campaign.autobid_uses_binom && _ctx.canUseAutobid)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_FieldDropdownNext, {
                            modelValue: _ctx.campaign.autobid_strategy,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.campaign.autobid_strategy) = $event)),
                            name: "autobid_strategy",
                            "errors-map": _ctx.campaignErrorsMap,
                            label: _ctx.$t('autobid_strategy'),
                            help: _ctx.$t('autobid_strategy_help'),
                            options: _ctx.CAMPAIGN_AUTOBID_STRATEGIES,
                            "option-label-translate": "",
                            "show-clear": ""
                          }, null, 8, ["modelValue", "errors-map", "label", "help", "options"]),
                          (_ctx.campaign.autobid_strategy === _ctx.CAMPAIGN_AUTOBID_STRATEGY_TARGET_CPA)
                            ? (_openBlock(), _createBlock(_component_FieldNumber, {
                                key: 0,
                                modelValue: _ctx.campaign.autobid_target_cpa,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.campaign.autobid_target_cpa) = $event)),
                                modelModifiers: { number: true },
                                name: "autobid_target_cpa",
                                "errors-map": _ctx.campaignErrorsMap,
                                label: _ctx.$t('autobid_target_cpa'),
                                help: _ctx.$t('autobid_target_cpa_help'),
                                min: 0,
                                "min-fraction-digits": 1,
                                "max-fraction-digits": 5,
                                prefix: "$"
                              }, null, 8, ["modelValue", "errors-map", "label", "help"]))
                            : _createCommentVNode("", true),
                          (_ctx.campaign.autobid_strategy === _ctx.CAMPAIGN_AUTOBID_STRATEGY_TARGET_ROI)
                            ? (_openBlock(), _createBlock(_component_FieldNumber, {
                                key: 1,
                                modelValue: _ctx.campaign.autobid_target_roi,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.campaign.autobid_target_roi) = $event)),
                                modelModifiers: { number: true },
                                name: "autobid_target_roi",
                                "errors-map": _ctx.campaignErrorsMap,
                                label: _ctx.$t('autobid_target_roi'),
                                help: _ctx.$t('autobid_target_roi_help'),
                                min: -99,
                                step: 1,
                                "max-fraction-digits": 0,
                                suffix: "%"
                              }, null, 8, ["modelValue", "errors-map", "label", "help"]))
                            : _createCommentVNode("", true),
                          (_ctx.campaign.autobid_strategy)
                            ? (_openBlock(), _createBlock(_component_FieldDropdownNext, {
                                key: 2,
                                modelValue: _ctx.campaign.autobid_conversion_event,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.campaign.autobid_conversion_event) = $event)),
                                name: "autobid_conversion_event",
                                "errors-map": _ctx.campaignErrorsMap,
                                label: _ctx.$t('autobid_conversion_event'),
                                help: _ctx.$t('autobid_conversion_event_help'),
                                placeholder: _ctx.$t('conversion_event_any'),
                                options: _ctx.CONVERSION_EVENTS,
                                "option-label-translate": "",
                                "show-clear": ""
                              }, null, 8, ["modelValue", "errors-map", "label", "help", "placeholder", "options"]))
                            : _createCommentVNode("", true),
                          (_ctx.campaign.autobid_strategy)
                            ? (_openBlock(), _createBlock(_component_FieldNumber, {
                                key: 3,
                                modelValue: _ctx.campaign.autobid_min_cost,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.campaign.autobid_min_cost) = $event)),
                                modelModifiers: { number: true },
                                name: "autobid_min_cost",
                                "errors-map": _ctx.campaignErrorsMap,
                                label: _ctx.$t('autobid_min_cost'),
                                help: _ctx.$t('autobid_min_cost_help'),
                                min: 0,
                                "min-fraction-digits": 1,
                                "max-fraction-digits": 5,
                                prefix: "$"
                              }, null, 8, ["modelValue", "errors-map", "label", "help"]))
                            : _createCommentVNode("", true),
                          (_ctx.campaign.autobid_strategy)
                            ? (_openBlock(), _createBlock(_component_FieldNumber, {
                                key: 4,
                                modelValue: _ctx.campaign.autobid_max_bid,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.campaign.autobid_max_bid) = $event)),
                                modelModifiers: { number: true },
                                name: "autobid_max_bid",
                                "errors-map": _ctx.campaignErrorsMap,
                                label: _ctx.$t('autobid_max_bid'),
                                help: _ctx.$t('autobid_max_bid_help'),
                                min: 0,
                                "min-fraction-digits": 1,
                                "max-fraction-digits": 5,
                                prefix: "$"
                              }, null, 8, ["modelValue", "errors-map", "label", "help"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.campaign.uses_bulk_segment_bids)
                    ? (_openBlock(), _createBlock(_Suspense, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CustomBids, {
                            modelValue: _ctx.campaign.bids_by_endpoints_uids,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.campaign.bids_by_endpoints_uids) = $event)),
                            title: _ctx.$t('bid_by_zones_uids', { type: _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM ? 'CPM' : 'CPC' }),
                            "entry-title": _ctx.$t('zone_uid'),
                            "per-thousand": _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM,
                            min: 0
                          }, {
                            key: _withCtx(({ customBid }) => [
                              _createVNode(_component_FieldNumber, {
                                class: "mb-0",
                                modelValue: customBid.key,
                                "onUpdate:modelValue": ($event: any) => ((customBid.key) = $event),
                                modelModifiers: { number: true },
                                "use-grouping": false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            actions: _withCtx(({ customBids, refresh }) => [
                              (_ctx.buildAverageZoneBidMatches(customBids).length)
                                ? (_openBlock(), _createBlock(_component_PrimeVueButton, {
                                    key: 0,
                                    class: "p-button-success p-button-outlined w-full mt-2",
                                    label: _ctx.$t('apply_average_bid'),
                                    icon: "pi pi-bolt",
                                    onClick: ($event: any) => (_ctx.applyAverageZoneBids(customBids, refresh))
                                  }, null, 8, ["label", "onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "title", "entry-title", "per-thousand"])
                        ]),
                        fallback: _withCtx(() => [
                          _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.user.isStaff())
                    ? (_openBlock(), _createBlock(_Suspense, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CustomBids, {
                            modelValue: _ctx.campaign.bids_by_referrers_uuids,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.campaign.bids_by_referrers_uuids) = $event)),
                            title: _ctx.$t('bid_by_referrers_uuids', { type: _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM ? 'CPM' : 'CPC' }),
                            "entry-title": _ctx.$t('referrer_uuid'),
                            "per-thousand": _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM,
                            min: 0,
                            "key-validator": _ctx.validateUuid,
                            "allow-bulk": ""
                          }, {
                            key: _withCtx(({ customBid }) => [
                              _createVNode(_component_FieldText, {
                                modelValue: customBid.key,
                                "onUpdate:modelValue": ($event: any) => ((customBid.key) = $event),
                                modelModifiers: { trim: true },
                                style: {"margin-bottom":"0 !important"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "title", "entry-title", "per-thousand", "key-validator"])
                        ]),
                        fallback: _withCtx(() => [
                          _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.campaign.uses_bulk_segment_bids)
                    ? (_openBlock(), _createBlock(_Suspense, { key: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CustomBids, {
                            modelValue: _ctx.campaign.bids_by_subids_uuids,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.campaign.bids_by_subids_uuids) = $event)),
                            title: _ctx.$t('bid_by_subids_uuids', { type: _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM ? 'CPM' : 'CPC' }),
                            "entry-title": _ctx.$t('subid_uuid'),
                            "per-thousand": _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM,
                            min: 0,
                            "key-validator": _ctx.validateUuid,
                            "allow-bulk": ""
                          }, {
                            key: _withCtx(({ customBid }) => [
                              _createVNode(_component_FieldText, {
                                modelValue: customBid.key,
                                "onUpdate:modelValue": ($event: any) => ((customBid.key) = $event),
                                modelModifiers: { trim: true },
                                style: {"margin-bottom":"0 !important"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "title", "entry-title", "per-thousand", "key-validator"])
                        ]),
                        fallback: _withCtx(() => [
                          _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_PrimeVueMessage, {
                        key: 4,
                        class: "mb-5",
                        severity: "warn"
                      }, {
                        default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                          _createElementVNode("div", null, "This campaign's bids are owned by an external system via the API.", -1)
                        ]))]),
                        _: 1
                      }))
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _cache[102] || (_cache[102] = _createElementVNode("div", { class: "card-title" }, [
                    _createElementVNode("h6", null, "Bid Booster")
                  ], -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.bid_booster_chance,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.campaign.bid_booster_chance) = $event)),
                      modelModifiers: { number: true },
                      name: "bid_booster_chance",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('bid_booster_chance'),
                      min: 0,
                      max: 20,
                      step: 1,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      suffix: "%"
                    }, null, 8, ["modelValue", "errors-map", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.bid_booster_multiplier,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.campaign.bid_booster_multiplier) = $event)),
                      modelModifiers: { number: true },
                      name: "bid_booster_multiplier",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('bid_booster_multiplier'),
                      min: 1,
                      max: 20,
                      "max-fraction-digits": 1,
                      step: 0.5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus"
                    }, null, 8, ["modelValue", "errors-map", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.revshare,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.campaign.revshare) = $event)),
                      modelModifiers: { number: true },
                      name: "revshare",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('revshare'),
                      min: 1,
                      max: 500,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      suffix: "%"
                    }, null, 8, ["modelValue", "errors-map", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.max_spending_per_day,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.campaign.max_spending_per_day) = $event)),
                  modelModifiers: { number: true },
                  name: "max_spending_per_day",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('max_spending_per_day'),
                  help: _ctx.$t('max_spending_per_day_help'),
                  min: 0,
                  step: 5,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus",
                  prefix: "$"
                }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.max_spending_per_endpoint_per_day,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.campaign.max_spending_per_endpoint_per_day) = $event)),
                  modelModifiers: { number: true },
                  name: "max_spending_per_endpoint_per_day",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('max_spending_per_endpoint_per_day'),
                  help: _ctx.$t('max_spending_per_endpoint_per_day_help'),
                  min: 0,
                  step: 5,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus",
                  prefix: "$"
                }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.max_spending,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.campaign.max_spending) = $event)),
                  modelModifiers: { number: true },
                  name: "max_spent",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('max_spending'),
                  help: _ctx.$t('max_spending_help'),
                  min: 0,
                  step: 5,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus",
                  prefix: "$"
                }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                (_ctx.campaign.max_spending > 0)
                  ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                      key: 0,
                      modelValue: _ctx.campaign.spent_resets_monthly,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.campaign.spent_resets_monthly) = $event)),
                      label: _ctx.$t('spent_resets_monthly'),
                      help: _ctx.$t('spent_resets_monthly_help')
                    }, null, 8, ["modelValue", "label", "help"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPC && _ctx.campaign.max_spending_per_day > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.max_spending_per_day_strategy,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.campaign.max_spending_per_day_strategy) = $event)),
                      modelModifiers: { number: true },
                      name: "max_spending_per_day_strategy",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('max_spending_per_day_strategy'),
                      help: _ctx.campaign.max_spending_per_day_strategy === _ctx.CAMPAIGN_MAX_SPENDING_PER_DAY_STRATEGY_FAST ? _ctx.$t('fast_help') : _ctx.$t('smoothly_help'),
                      options: _ctx.CAMPAIGN_MAX_SPENDING_PER_DAY_STRATEGIES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "errors-map", "label", "help", "options"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.$t('conversion_charge')) + " 💸", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_FieldCheckbox, {
                  modelValue: _ctx.campaign.conversion_charge,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.campaign.conversion_charge) = $event)),
                  label: _ctx.$t('conversion_charge_enabled'),
                  help: _ctx.$t('conversion_charge_enabled_help')
                }, null, 8, ["modelValue", "label", "help"]),
                (_ctx.campaign.conversion_charge)
                  ? (_openBlock(), _createBlock(_component_FieldDropdownNext, {
                      key: 0,
                      modelValue: _ctx.campaign.conversion_charge_event,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.campaign.conversion_charge_event) = $event)),
                      name: "conversion_charge_event",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('conversion_charge_event'),
                      placeholder: _ctx.$t('conversion_event_any'),
                      options: _ctx.CONVERSION_EVENTS,
                      "option-label-translate": "",
                      "show-clear": ""
                    }, null, 8, ["modelValue", "errors-map", "label", "placeholder", "options"]))
                  : _createCommentVNode("", true),
                (_ctx.campaign.conversion_charge)
                  ? (_openBlock(), _createBlock(_component_FieldNumber, {
                      key: 1,
                      modelValue: _ctx.campaign.conversion_charge_amount,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.campaign.conversion_charge_amount) = $event)),
                      modelModifiers: { number: true },
                      name: "conversion_charge_amount",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('conversion_charge_amount'),
                      help: _ctx.$t('conversion_charge_amount_help'),
                      min: 0.01,
                      "min-fraction-digits": 1,
                      "max-fraction-digits": 5,
                      prefix: "$"
                    }, null, 8, ["modelValue", "errors-map", "label", "help"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPA)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.$t('test')) + " ⚗️", 1)
                    ]),
                    (!!_ctx.campaign.id)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                          (_ctx.campaign.test)
                            ? (_openBlock(), _createBlock(_component_PrimeVueTag, {
                                key: 0,
                                value: _ctx.$t('test_in_progess'),
                                severity: "info"
                              }, null, 8, ["value"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_PrimeVueTag, {
                                  value: _ctx.$t('test_is_done'),
                                  severity: "success"
                                }, null, 8, ["value"]),
                                (_ctx.campaign.test_is_failed)
                                  ? (_openBlock(), _createBlock(_component_PrimeVueTag, {
                                      key: 0,
                                      class: "ml-2",
                                      value: _ctx.$t('low_roi'),
                                      severity: "danger"
                                    }, null, 8, ["value"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.test_max_spending,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.campaign.test_max_spending) = $event)),
                      modelModifiers: { number: true },
                      name: "test_max_spending",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('test_max_spending'),
                      min: 0,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      prefix: "$"
                    }, null, 8, ["modelValue", "errors-map", "label"]),
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.test_max_spending_per_endpoint,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.campaign.test_max_spending_per_endpoint) = $event)),
                      modelModifiers: { number: true },
                      name: "test_max_spending_per_endpoint",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('test_max_spending_per_endpoint'),
                      min: 0,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      prefix: "$"
                    }, null, 8, ["modelValue", "errors-map", "label"]),
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.test_max_spending_per_subid,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.campaign.test_max_spending_per_subid) = $event)),
                      modelModifiers: { number: true },
                      name: "test_max_spending_per_subid",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('test_max_spending_per_subid'),
                      min: 0,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      prefix: "$"
                    }, null, 8, ["modelValue", "errors-map", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.max_clicks_per_ip,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.campaign.max_clicks_per_ip) = $event)),
                  modelModifiers: { number: true },
                  name: "max_clicks_per_ip",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('max_clicks_per_ip'),
                  help: _ctx.$t('max_clicks_per_ip_help'),
                  min: 0,
                  step: 1,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus"
                }, null, 8, ["modelValue", "errors-map", "label", "help"])
              ])
            ]),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.max_clicks_per_subid,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.campaign.max_clicks_per_subid) = $event)),
                      modelModifiers: { number: true },
                      name: "max_clicks_per_subid",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('max_clicks_per_subid'),
                      help: _ctx.$t('max_clicks_per_subid_help'),
                      min: 0,
                      step: 1,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus"
                    }, null, 8, ["modelValue", "errors-map", "label", "help"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createBlock(_Suspense, { key: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MaxClicksBySubids, {
                      modelValue: _ctx.campaign.max_clicks_by_subids_uuids,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.campaign.max_clicks_by_subids_uuids) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.$t('filters')) + " 👮", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_ip_mismatch,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.campaign.filter_ip_mismatch) = $event)),
                      label: _ctx.$t('filter_ip_mismatch')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_user_agent_mismatch,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.campaign.filter_user_agent_mismatch) = $event)),
                      label: _ctx.$t('filter_user_agent_mismatch')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_referrer_mismatch,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.campaign.filter_referrer_mismatch) = $event)),
                      label: _ctx.$t('filter_referrer_mismatch')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_proxy,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.campaign.filter_proxy) = $event)),
                      label: _ctx.$t('filter_proxy')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_has_no_js,
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.campaign.filter_has_no_js) = $event)),
                      label: _ctx.$t('filter_has_no_js')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_iframe,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.campaign.filter_iframe) = $event)),
                      label: _ctx.$t('filter_iframe')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_headless,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.campaign.filter_headless) = $event)),
                      label: _ctx.$t('filter_headless')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_double_click,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.campaign.filter_double_click) = $event)),
                      label: _ctx.$t('filter_double_click')
                    }, null, 8, ["modelValue", "label"]),
                    (_ctx.canHasCreatives)
                      ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                          key: 0,
                          modelValue: _ctx.campaign.filter_click_without_impression,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.campaign.filter_click_without_impression) = $event)),
                          label: _ctx.$t('filter_click_without_impression')
                        }, null, 8, ["modelValue", "label"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_56, [
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.$t('options')) + " 🤹🏼", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    (!_ctx.user.isLimitedManager())
                      ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                          key: 0,
                          modelValue: _ctx.campaign.is_builtin,
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.campaign.is_builtin) = $event)),
                          label: _ctx.$t('is_builtin_female')
                        }, null, 8, ["modelValue", "label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.redirect_type,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.campaign.redirect_type) = $event)),
                      modelModifiers: { number: true },
                      name: "redirect_type",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: "Redirect type",
                      options: _ctx.REDIRECT_TYPES
                    }, null, 8, ["modelValue", "errors-map", "options"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.adsecure,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.campaign.adsecure) = $event)),
                      label: "AdSecure"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.has_violations,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.campaign.has_violations) = $event)),
                      label: _ctx.$t('has_violations')
                    }, null, 8, ["modelValue", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.approval_status,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.campaign.approval_status) = $event)),
                  modelModifiers: { number: true },
                  name: "approval_status",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('approval_status'),
                  disabled: _ctx.user.isAffiliate(),
                  options: _ctx.CAMPAIGN_APPROVAL_STATUSES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"]),
                (_ctx.campaign.approval_status === _ctx.CAMPAIGN_APPROVAL_STATUS_DECLINED)
                  ? (_openBlock(), _createBlock(_component_ApprovalStatusComment, {
                      key: 0,
                      modelValue: _ctx.campaign.approval_status_comment,
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.campaign.approval_status_comment) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.status,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.campaign.status) = $event)),
                  modelModifiers: { number: true },
                  name: "status",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('status'),
                  options: _ctx.CAMPAIGN_STATUSES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "errors-map", "label", "options"])
              ])
            ]),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_FieldTextarea, {
                      modelValue: _ctx.campaign.comment,
                      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.campaign.comment) = $event)),
                      modelModifiers: { trim: true },
                      name: "comment",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('comment')
                    }, null, 8, ["modelValue", "errors-map", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!_ctx.campaign.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.campaign.created_at,
                      label: _ctx.$t('created_at'),
                      disabled: ""
                    }, null, 8, ["model-value", "label"]),
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.campaign.updated_at,
                      label: _ctx.$t('updated_at'),
                      disabled: ""
                    }, null, 8, ["model-value", "label"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('targeting_settings')) + " 🎯", 1),
        _createElementVNode("div", _hoisted_67, [
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('traffic_source')), 1),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_traffic_source,
                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.campaign.targeting_by_traffic_source) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_traffic_source",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES_BY_TRAFFIC_SOURCE,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('traffic_category')), 1),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_traffic_category,
                  "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.campaign.targeting_by_traffic_category) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_traffic_category",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES_BY_TRAFFIC_CATEGORY,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('countries')), 1),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_countries,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.campaign.targeting_by_countries) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_countries",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_countries !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_component_FieldListBox, {
                      key: 0,
                      modelValue: _ctx.campaign.countries_ids,
                      "onUpdate:modelValue": [
                        _cache[62] || (_cache[62] = ($event: any) => ((_ctx.campaign.countries_ids) = $event)),
                        _ctx.onCountriesIdsChange
                      ],
                      loading: _ctx.countriesLoading,
                      invalid: !_ctx.campaign.countries_ids.length,
                      options: _ctx.countries.data,
                      "option-value": "id",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "loading", "invalid", "options", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.campaign.countries_ids.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('regions')), 1),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_regions_ids,
                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.campaign.targeting_by_regions_ids) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_regions_ids",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_regions_ids !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBox, {
                          key: 0,
                          modelValue: _ctx.campaign.regions_ids,
                          "onUpdate:modelValue": [
                            _cache[64] || (_cache[64] = ($event: any) => ((_ctx.campaign.regions_ids) = $event)),
                            _ctx.onRegionsIdsChange
                          ],
                          loading: _ctx.regionsLoading,
                          invalid: !_ctx.campaign.regions_ids.length,
                          options: _ctx.regions.data,
                          "option-value": "id",
                          "option-label": "compiled_name"
                        }, null, 8, ["modelValue", "loading", "invalid", "options", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.campaign.regions_ids.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('cities')), 1),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_cities_ids,
                      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.campaign.targeting_by_cities_ids) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_cities_ids",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_cities_ids !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBoxRemote, {
                          key: 0,
                          modelValue: _ctx.campaign.cities_ids,
                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.campaign.cities_ids) = $event)),
                          invalid: !_ctx.campaign.cities_ids.length,
                          "api-url": "/api/v3/cities/options",
                          "api-params": _ctx.citiesParams
                        }, null, 8, ["modelValue", "invalid", "api-params"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('languages')), 1),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_languages_codes,
                  "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.campaign.targeting_by_languages_codes) = $event)),
                  name: "targeting_by_languages_codes",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_languages_codes !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_component_FieldListBox, {
                      key: 0,
                      modelValue: _ctx.campaign.languages_codes,
                      "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.campaign.languages_codes) = $event)),
                      loading: _ctx.languagesLoading,
                      invalid: !_ctx.campaign.languages_codes.length,
                      options: _ctx.languages.data,
                      "option-value": "code",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "loading", "invalid", "options"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('platforms')), 1),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_platforms,
                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.campaign.targeting_by_platforms) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_platforms",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_platforms !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createVNode(_component_PrimeVueButton, {
                            class: "p-button-outlined w-full",
                            label: _ctx.$t('desktop'),
                            onClick: _ctx.selectDesktopPlatforms
                          }, null, 8, ["label", "onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_92, [
                          _createVNode(_component_PrimeVueButton, {
                            class: "p-button-outlined w-full",
                            label: _ctx.$t('mobile'),
                            onClick: _ctx.selectMobilePlatforms
                          }, null, 8, ["label", "onClick"])
                        ])
                      ]),
                      _createVNode(_component_FieldListBox, {
                        modelValue: _ctx.campaign.platforms_ids,
                        "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.campaign.platforms_ids) = $event)),
                        loading: _ctx.platformsLoading,
                        invalid: !_ctx.campaign.platforms_ids.length,
                        options: _ctx.platforms.data,
                        "option-value": "id",
                        "option-label": "name"
                      }, null, 8, ["modelValue", "loading", "invalid", "options"])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('browsers')), 1),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_browsers,
                  "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.campaign.targeting_by_browsers) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_browsers",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_browsers !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_component_FieldListBox, {
                      key: 0,
                      modelValue: _ctx.campaign.browsers_ids,
                      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.campaign.browsers_ids) = $event)),
                      loading: _ctx.browsersLoading,
                      invalid: !_ctx.campaign.browsers_ids.length,
                      options: _ctx.browsers.data,
                      "option-value": "id",
                      "option-label": "name"
                    }, null, 8, ["modelValue", "loading", "invalid", "options"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        (_ctx.campaign.traffic_type === _ctx.TRAFFIC_TYPE_PUSH)
          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('subscriber_age')), 1),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_subscriber_age,
                      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.campaign.targeting_by_subscriber_age) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_subscriber_age",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES_BY_SUBSCRIBER_AGE,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('campaign_connection_type')), 1),
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.connection_type,
                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.campaign.connection_type) = $event)),
                  modelModifiers: { number: true },
                  name: "connection_type",
                  label: _ctx.$t('campaign_connection_type'),
                  options: _ctx.CAMPAIGN_CONNECTION_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('ips')), 1),
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_ips,
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.campaign.targeting_by_ips) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_ips",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              (_ctx.campaign.targeting_by_ips !== _ctx.TARGETING_TYPE_DISABLED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                    _createVNode(_component_FieldTextarea, {
                      modelValue: _ctx.campaign.ips,
                      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.campaign.ips) = $event)),
                      modelModifiers: { trim: true },
                      name: "ips",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('ips'),
                      help: _ctx.$t('ips_help'),
                      invalid: !_ctx.campaign.ips?.length
                    }, null, 8, ["modelValue", "errors-map", "label", "help", "invalid"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('carriers')), 1),
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_carriers_ids,
                  "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.campaign.targeting_by_carriers_ids) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_carriers_ids",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              (_ctx.campaign.targeting_by_carriers_ids !== _ctx.TARGETING_TYPE_DISABLED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                    _createVNode(_component_FieldListBox, {
                      modelValue: _ctx.campaign.carriers_ids,
                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.campaign.carriers_ids) = $event)),
                      loading: _ctx.carriersLoading,
                      invalid: !_ctx.campaign.carriers_ids.length,
                      options: _ctx.carriers.data,
                      "option-value": "id",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "loading", "invalid", "options"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_112, [
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('endpoints')), 1),
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_endpoints_ids,
                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.campaign.targeting_by_endpoints_ids) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_endpoints_ids",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_endpoints_ids !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBox, {
                          key: 0,
                          modelValue: _ctx.campaign.endpoints_ids,
                          "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.campaign.endpoints_ids) = $event)),
                          name: "endpoints_ids",
                          "errors-map": _ctx.campaignErrorsMap,
                          label: _ctx.$t('endpoints'),
                          loading: _ctx.endpointsLoading,
                          invalid: !_ctx.campaign.endpoints_ids.length,
                          options: _ctx.endpoints.data,
                          "option-value": "id",
                          "option-label": "compiled_name"
                        }, null, 8, ["modelValue", "errors-map", "label", "loading", "invalid", "options"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('zones_uids')), 1),
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("div", _hoisted_118, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_endpoints_uids,
                  "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.campaign.targeting_by_endpoints_uids) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_endpoints_uids",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_endpoints_uids !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TargetingByValues, {
                          modelValue: _ctx.campaign.endpoints_uids,
                          "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.campaign.endpoints_uids) = $event)),
                          "allow-int": "",
                          title: _ctx.$t('zones_uids'),
                          help: _ctx.$t('zones_uids_help')
                        }, null, 8, ["modelValue", "title", "help"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('referrers_hosts')), 1),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_referrers_hosts,
                      "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.campaign.targeting_by_referrers_hosts) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_referrers_hosts",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_referrers_hosts !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TargetingByValues, {
                              modelValue: _ctx.campaign.referrers_hosts,
                              "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.campaign.referrers_hosts) = $event)),
                              "allow-any": "",
                              title: _ctx.$t('referrers_hosts'),
                              help: _ctx.$t('referrers_hosts_help')
                            }, null, 8, ["modelValue", "title", "help"])
                          ]),
                          fallback: _withCtx(() => [
                            _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('referrers_uuids')), 1),
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", _hoisted_124, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_referrers_uuids,
                      "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.campaign.targeting_by_referrers_uuids) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_referrers_uuids",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_referrers_uuids !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TargetingByValues, {
                              modelValue: _ctx.campaign.referrers_uuids,
                              "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.campaign.referrers_uuids) = $event)),
                              "allow-any": "",
                              title: _ctx.$t('referrers_uuids'),
                              help: _ctx.$t('referrers_uuids_help')
                            }, null, 8, ["modelValue", "title", "help"])
                          ]),
                          fallback: _withCtx(() => [
                            _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_125, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('subids_uuids')), 1),
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("div", _hoisted_127, [
                _createVNode(_component_FieldCheckbox, {
                  modelValue: _ctx.campaign.use_quality_presets,
                  "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.campaign.use_quality_presets) = $event)),
                  label: _ctx.$t('use_quality_presets')
                }, null, 8, ["modelValue", "label"]),
                (_ctx.campaign.use_quality_presets)
                  ? (_openBlock(), _createBlock(_component_FieldListBox, {
                      key: 0,
                      modelValue: _ctx.campaign.quality_presets_ids,
                      "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.campaign.quality_presets_ids) = $event)),
                      name: "quality_presets_ids",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('quality_presets'),
                      loading: _ctx.qualityPresetsLoading,
                      invalid: !_ctx.campaign.quality_presets_ids.length,
                      options: _ctx.qualityPresets.data,
                      "option-value": "id",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "errors-map", "label", "loading", "invalid", "options"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_subids,
                  "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.campaign.targeting_by_subids) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_subids",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_subids !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_Suspense, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TargetingByValues, {
                          modelValue: _ctx.campaign.subids_uuids,
                          "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.campaign.subids_uuids) = $event)),
                          "allow-uuid": "",
                          title: _ctx.$t('subids_uuids'),
                          help: _ctx.$t('subids_uuids_help')
                        }, null, 8, ["modelValue", "title", "help"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_128, [
          _createElementVNode("div", _hoisted_129, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ScheduleByHours, {
                  modelValue: _ctx.campaign.hours,
                  "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.campaign.hours) = $event)),
                  "hide-schedule": _ctx.campaign.targeting_by_hours === _ctx.TARGETING_TYPE_DISABLED
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_130, [
                      _createVNode(_component_FieldDropdownNext, {
                        modelValue: _ctx.campaign.targeting_by_hours,
                        "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.campaign.targeting_by_hours) = $event)),
                        modelModifiers: { number: true },
                        name: "targeting_by_hours",
                        label: _ctx.$t('targeting_type'),
                        options: _ctx.TARGETING_TYPES,
                        "option-label-translate": ""
                      }, null, 8, ["modelValue", "label", "options"])
                    ]),
                    (_ctx.campaign.targeting_by_hours !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                          _createVNode(_component_FieldTimezone, {
                            modelValue: _ctx.campaign.targeting_by_hours_timezone,
                            "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.campaign.targeting_by_hours_timezone) = $event)),
                            label: "Timezone",
                            placeholder: "Visitor's local time"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "hide-schedule"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
              ]),
              _: 1
            }))
          ]),
          _createElementVNode("div", _hoisted_132, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ScheduleByDays, {
                  modelValue: _ctx.campaign.days,
                  "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.campaign.days) = $event)),
                  "hide-schedule": _ctx.campaign.targeting_by_days === _ctx.TARGETING_TYPE_DISABLED
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_133, [
                      _createVNode(_component_FieldDropdownNext, {
                        modelValue: _ctx.campaign.targeting_by_days,
                        "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.campaign.targeting_by_days) = $event)),
                        modelModifiers: { number: true },
                        name: "targeting_by_days",
                        label: _ctx.$t('targeting_type'),
                        options: _ctx.TARGETING_TYPES,
                        "option-label-translate": ""
                      }, null, 8, ["modelValue", "label", "options"])
                    ]),
                    (_ctx.campaign.targeting_by_days !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                          _createVNode(_component_FieldTimezone, {
                            modelValue: _ctx.campaign.targeting_by_days_timezone,
                            "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.campaign.targeting_by_days_timezone) = $event)),
                            label: "Timezone",
                            placeholder: "Visitor's local time"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "hide-schedule"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
              ]),
              _: 1
            }))
          ]),
          _createElementVNode("div", _hoisted_135, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _cache[103] || (_cache[103] = _createElementVNode("h5", null, "Start & stop at", -1)),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", _hoisted_137, [
                      _createVNode(_component_FieldTimezone, {
                        modelValue: _ctx.campaign.start_stop_at_timezone,
                        "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.campaign.start_stop_at_timezone) = $event)),
                        label: "Timezone"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_138, [
                      _createVNode(_component_FieldDate, {
                        modelValue: _ctx.campaign.start_at,
                        "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.campaign.start_at) = $event)),
                        label: "Start at",
                        help: "Traffic starts on this date. The campaign must be Enabled.",
                        "show-time": true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_139, [
                      _createVNode(_component_FieldDate, {
                        modelValue: _ctx.campaign.stop_at,
                        "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.campaign.stop_at) = $event)),
                        label: "Stop at",
                        help: "Stops traffic after this date without disabling the campaign.",
                        "show-time": true
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
              ]),
              _: 1
            }))
          ])
        ]),
        (!!_ctx.campaign.id && _ctx.user.isStaff())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[104] || (_cache[104] = _createElementVNode("h3", null, "Miscellaneous ℹ️", -1)),
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("div", _hoisted_141, [
                  (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_AdSecure, {
                        filters: { campaign_id: _ctx.campaign.id },
                        "show-relations-columns": false
                      }, null, 8, ["filters"])
                    ]),
                    fallback: _withCtx(() => [
                      _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                    ]),
                    _: 1
                  }))
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "entry", "entry-errors-map", "entry-fetch-handler", "entry-store-handler"])
  ], 64))
}